import { useEffect, useRef } from "react"

export const EmbedCommercialScenarios = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    const iframe = iframeRef.current
    const allowedOrigin = new URL(iframe.src).origin // lock down if you know it
    const handleMessage = (e: MessageEvent) => {
      if (e.origin !== allowedOrigin) return              // security (or drop this line if you must)
      if (!e.data || e.data.type !== 'embed-size') return // ignore other messages
      iframe.style.height = e.data.height + 'px'
    }

    window.addEventListener('message', handleMessage)

    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return <iframe src={`https://www.oneethos.com/commercial-solar-prescreener`}
    className="commercial-scenarios-iframe"
    ref={iframeRef}
  />
}
